export default theme => ({
  header: {
    display: "flex",
    alignItems: "center",
  },
  header__handle: {
    cursor: "move",
    marginRight: "3rem",
  },
  header__checkbox: {
    marginRight: "3rem",
  },
  header__preview: {
    marginRight: "3rem",
  },
  header__preview__codename: {
    margin: "0rem 3rem",
  },
});
